import { AuctionLotModel } from ".";

export class MyAuctionLotModel {
    Id: number;
    AuctionLot: AuctionLotModel;
    AuctionLotId: number;
    CustomerId: number;
    WatchingOnly: boolean;
    IsHidden: boolean;
    BidDate?: Date;
    MinimumNextBid?: number;
    BidAmount?: number;
    /**
     * Saved/temporary bid amount
     */
    SavedBidAmount?: number;
    AutoBidAmount?: number;
    TempBidAmount?: number;
    TempAutoBidAmount?: number;
    TempBuyerPremiumAmount?: number;
    IsWinning: boolean;

    constructor() {
    }
}